import "@switchsystems/coactive-vue-lib/styles";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "vue-select/dist/vue-select.css";
import "@/assets/scss/app.scss";

import { createApp, h } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { abilitiesPlugin } from "@casl/vue";
import { createMongoAbility } from "@casl/ability";
import { createI18n } from "vue-i18n";
import { createBootstrap } from "bootstrap-vue-next";
import PrimeVue, { defaultOptions } from "primevue/config";
import Tooltip from "primevue/tooltip";
import ConfirmationService from "primevue/confirmationservice";
import { createHead } from "@unhead/vue/client";
import VueForceNextTick from "vue-force-next-tick";
import Toast from "vue-toastification";
import {
  Api,
  useAuthStore,
  pinia,
  PrimevuePassthruBootstrap,
} from "@switchsystems/coactive-vue-lib";
import localStoragePlugin from "./store/localStoragePlugin";
import indexdbStoragePlugin from "./store/indexdbStoragePlugin";
import App from "./App.vue";
import awsExports, { storage } from "./aws-exports";
import store from "./store";
import router from "./router";
import messages from "./locales";
import "./icons";

const app = createApp({
  render: () => h(App),
});

Api.init(awsExports, storage);
const api = new Api();
store.$api = api;
app.provide("api", api);

pinia.use(localStoragePlugin);
pinia.use(indexdbStoragePlugin);
app.use(pinia);
const authStore = useAuthStore();
app.use(abilitiesPlugin, createMongoAbility(authStore.ability), {
  useGlobalProperties: true, // backwards compatibility for existing $ability usage
});
app.use(createHead());

app.use(VueForceNextTick);
app.provide("forceNextTick", app.config.globalProperties.$forceNextTick);
app.use(
  createI18n({
    locale: "en",
    messages,
  }),
);
app.use(router);
app.use(store);
app.use(createBootstrap());
app.use(PrimeVue, {
  unstyled: true,
  pt: PrimevuePassthruBootstrap,
  locale: {
    ...defaultOptions.locale,
    firstDayOfWeek: 1,
    dateFormat: "dd/mm/yy",
  },
});
app.directive("tooltip", Tooltip);
app.use(ConfirmationService);
app.use(Toast, {
  shareAppContext: true,
  onMounted: (_, toastApp) => {
    // shareAppContext seems to be broken
    // globally registered components work in the toast
    // but symbol injection does not unless they are manually bound here
    toastApp.use(router);
    toastApp.use(store);
    toastApp.use(pinia);
  },
});
app.component("FontAwesomeIcon", FontAwesomeIcon);
app.mount("#app");
